import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { MyQuotationsRowItems } from '../../models/Quotations';

export const MyQuotationsTableRow: React.FC<MyQuotationsRowItems> = (props) => {
    const { row, index, clickHandle, selected } = props;
    const isSelected = (name: string) => selected.indexOf(name) !== -1;
    const isItemSelected = isSelected(row.quoteID.toString());
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <>
            <TableRow
                hover
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
            >
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                            'aria-labelledby': labelId,
                        }}
                        onClick={(event) =>
                            clickHandle(event, row.quoteID.toString())
                        }
                    />
                </TableCell>
                <TableCell
                    component="th"
                    id={labelId}
                    scope="row"
                    padding="none"
                >
                    {row.quoteID}
                </TableCell>
                <TableCell>
                    {t('TABLE_ROW.QUOTE_COUNT', { count: row.count })}
                </TableCell>
                <TableCell>{row.orderDate}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell align="right">{t('TABLE_ROW.DETAILS')}</TableCell>
            </TableRow>
        </>
    );
};
